import { buildPath } from '../../../system-utils/api-utils';
import Config from '../../../system-utils/config-manager';

export const constructGetLongTermTokenApiUrl = (bankId: string) => buildPath(`${Config.get('microservice_base_url')}${Config.get('endpoints.token_exchange')}`, { bank_id: bankId });
export const constructGetPublicKeyApiUrl = () => `${Config.get('microservice_base_url')}${Config.get('endpoints.get_public_key')}`;

export const constructGetShortTermTokenApiUrl = (partnerCode: string) => buildPath(`${Config.get('microservice_base_url_api')}${Config.get('endpoints.tpauth_token_shortterm')}`, { partner_code: partnerCode });
export const constructGet9SpokesRedirectApiUrl = () => `${Config.get('microservice_base_url_api')}${Config.get('endpoints.tpauth_token_tpredirect')}`;
